import { useTheme } from "../lib/ThemeContext";

export const Logo = ({ size = "md" }) => {
  const { theme } = useTheme();
  const h = size === "lg" ? "h-16" : "h-11";
  return (
    <img
      src={theme === "dark" ? "/logo-dark.png" : "/logo-light.png"}
      alt="MSG — Mark Signs & Graphics"
      className={`${h} w-auto select-none`}
      data-testid="msg-logo"
      draggable={false}
    />
  );
};
